import { SchedulerWorkOrderOnMachine } from '../../../common/scheduler/models/wo-on-machine';
import { Stage } from '../../../api/elite/types/stages';
import { FilterWorkOrder } from '@dep/filters/models/item';

export class FiltersWorkOrderOnMachine extends SchedulerWorkOrderOnMachine {
  workOrder: FilterWorkOrder;
  stages: Stage[] = [];

  get currentStage(): Stage | undefined {
    return this.stages?.length > 0 ? this.stages[0] : null;
  }

  static fromObject(
    object: Partial<FiltersWorkOrderOnMachine>
  ): FiltersWorkOrderOnMachine {
    const itemMachine = new FiltersWorkOrderOnMachine();
    Object.assign(itemMachine, object);
    itemMachine.workOrder = FilterWorkOrder.fromObject(object.workOrder);
    itemMachine.workOrder.machinesWorkOrders = [itemMachine];
    return itemMachine;
  }
}
